<template>
  <v-dialog
    v-model="planDialog"
    width="520px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Resolve Conflict</span>
          <i
            class="el-icon-close"
            @click="changeDialog"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div class="flex-content">
          <p class="waring-tip">This quote's information does not match those in the user's profile.</p>
          <p class="waring-tip">Do you want to use the profile's information to replace this quote's?</p>
          <div class="flex flex-sb flex-aglin">
            <div class="flex-box">
              <div class="flex-info tr">
                <span>This Quote</span>
              </div>
              <div
                v-for="(item, index) in replace_pop.this_quote"
                :key="index"
                class="flex-info">
                <span>{{ item.label }}</span>
                <span class="text-underline">{{ item.val }}</span>
              </div>
            </div>
            <div>
              <font-awesome-icon icon="angle-right"></font-awesome-icon>
            </div>
            <div class="flex-box">
              <div class="flex-info tr">
                <span>User Profile</span>
              </div>
              <div
                v-for="(item, index) in replace_pop.user_pro"
                :key="index"
                class="flex-info">
                <span>{{ item.label }}</span>
                <span>{{ item.val  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex footer-button">
        <v-button @click="changeDialog">Cancel</v-button>
        <v-button
          type="success"
          @click="ConfirmCoupon">Confirm</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'replaceDialog',
  components:{
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    selectData:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return {
      planDialog: false,
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    replace_pop(){
      let{replace_pop} = this.selectData
      return replace_pop||{}
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
      }
    },
  },
  methods: {
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      this.planDialog =false
      this.$emit('confirm')
    },
    network() {
      return {
        addCustomer: async (params) => {
          const {data} = await addCustomer({
            order_id: this.form.oder_id,
            customer_id:this.selectData.id,
          })
          this.$emit('saveManual')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  .dialog-container {
    //padding: 15px;
    border-radius: 5px;
    .plan-header {
      background: #F6F8FA;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:10px 10px 10px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
        i{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .dialog-body{
      padding: 15px;
      max-height: 800px;
      overflow-y: auto;
    }
    .footer-button{
      padding: 15px;
      justify-content: space-between;
    }
    .flex-content {
      //width: 280px;
      .flex-aglin{
        align-items: center;
        font-size: 24px;
      }
      .text-underline{
        text-decoration: line-through ;
      }
      .flex-box {
        border-radius: 5px;
        border: 1px solid #E1E4E8;
        //width: 280px;
        margin: 16px 0;
        width: 45%;
        .flex-info {
          display: flex;
          justify-content: space-between;
          padding: 10px 10px;
          border-bottom: 1px solid #E1E4E8;

          span:first-child {
            color: #586069;
            font-size: 14px;
            font-weight: 500;
          }

          span:last-child {
            color: #24292E;
            font-size: 14px;
          }
          &:last-child{
            border-bottom: 0;
          }
        }

      }
    }
    .waring-tip {
      color: rgb(205, 43, 56) !important;
      font-size: 14px;
      font-weight: 500;

    }
    .tr{
      background-color: #F6F8FA !important;
    }
  }
</style>
